"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.States = void 0;
class States {
    constructor(initialState) {
        this._listeners = new Set();
        this._isDisposed = false;
        this._state = initialState;
        this.onTransition = this.onTransition.bind(this);
    }
    get isDisposed() {
        return this._isDisposed;
    }
    get() {
        return this._state;
    }
    match(...args) {
        const matches = args[1] || args[0];
        const state = args.length === 2 ? args[0] : this._state;
        return matches[state.state] ? matches[state.state](state) : matches._();
    }
    set(state) {
        if (this._isDisposed) {
            return;
        }
        const prevState = this._state;
        this._state = state;
        this._listeners.forEach((listener) => listener(state, prevState));
        return state;
    }
    is(state) {
        return this._state.state === state;
    }
    onTransition(...args) {
        if (this._isDisposed) {
            return;
        }
        let listener;
        if (typeof args[0] === "string" && typeof args[1] === "function") {
            const state = args[0];
            listener = (currentState, prevState) => {
                if (currentState.state === state) {
                    args[1](currentState, prevState);
                }
            };
        }
        else if (typeof args[0] === "function") {
            listener = args[0];
        }
        else {
            throw new Error("You are giving the wrong arguments");
        }
        this._listeners.add(listener);
        return () => {
            this._listeners.delete(listener);
        };
    }
    dispose() {
        this._listeners.clear();
        this._isDisposed = true;
    }
}
exports.States = States;
